import { render, staticRenderFns } from "./SelectPhoneCode.vue?vue&type=template&id=2a4fc98a&scoped=true"
import script from "./SelectPhoneCode.vue?vue&type=script&lang=js"
export * from "./SelectPhoneCode.vue?vue&type=script&lang=js"
import style0 from "./SelectPhoneCode.vue?vue&type=style&index=0&id=2a4fc98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4fc98a",
  null
  
)

export default component.exports